/**
 * 物流选择
 * 这部分渲染代码因为耦合在sku组件内部，所以暂时没有迁移
 * 具体的渲染代码参考sku-attrs下的deal-warehouse文件
 */
import React from 'react';

const WarehouseSelector = ({ style }) => {
  return (
    <div id="warehouse-selector" className="market-action-item" style={style} />
  );
};

export default WarehouseSelector;
